export default {
    allDevices: state => state.allDevices,
    allDevicesPagedWithLocations: state => state.allDevicesPagedWithLocations,
    beaconLogs: state => state.beaconLogs,
    devicesSummary: state => state.devicesSummary,
    devicesCampaigns: state => state.devicesCampaigns,
    requestsByDevice: state => state.requestsByDevice,
    devicesStatusLogs: state => state.devicesStatusLogs,
    recentReports: state => state.recentReports
}
